import { useFeatureFlag } from '@agentnet/feature-flags';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { PropertyOrderInsightsProps } from 'api/file/interfaces/get-file-order-insights';
import React from 'react';
import { FeatureFlag } from 'utilities/constants/launch-darkly-flags';
import AssessedValue from './components/AssessedValue';
import EstMarketValue from './components/EstMarketValue';
import EstMortgageBalance from './components/EstMortgageBalance';
import FinCen from './components/FinCen';
import Occupancy from './components/Occupancy';
import OrderInsightAlert from './components/OrderInsightAlerts';
import OwnerName from './components/OwnerName';
import OwnersMailingAddress from './components/OwnersMailingAddress';
import PolicyLiability from './components/PolicyLiability';
import RecordedPropertyInfo from './components/RecordedPropertyInfo';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    w100: {
      width: '100%',
    },
  }),
);

const PropertyOrderInsights: React.FC<PropertyOrderInsightsProps> = ({
  property,
  policyLiabilityJacket,
  isPdf,
  index,
}) => {
  const classes = useStyles();
  const showFincenInOI = useFeatureFlag(FeatureFlag.SHOW_FINCEN_IN_ORDER_INSIGHTS, false);

  return (
    <div className={classes.w100}>
      {property.risks?.some((x) => x.categoryName === 'Property' && x.typeName === 'MissingData') && (
        <>
          <OrderInsightAlert
            errorMessages={['Order Insights Unavailable: Address Match Not Found']}
            isPdf={isPdf}
            hasErrorMessagesHtml
          />
          {property.risks?.some(
            (risk) =>
              risk.categoryName === 'PropertyInfo' &&
              (risk.typeName === 'ClaimProperty' || risk.typeName === 'WatchListProperty'),
          ) && (
            <OrderInsightAlert
              isPdf={isPdf}
              alerts={
                property.risks?.filter(
                  (risk) =>
                    risk.categoryName === 'PropertyInfo' &&
                    (risk.typeName === 'ClaimProperty' || risk.typeName === 'WatchListProperty'),
                ) ?? []
              }
            />
          )}
        </>
      )}

      {property.propertyDetailId && (
        <>
          <RecordedPropertyInfo property={property} isPdf={isPdf} />
          <OwnerName property={property} isPdf={isPdf} />
          <OwnersMailingAddress property={property} isPdf={isPdf} />
          <Occupancy property={property} isPdf={isPdf} />
          <EstMarketValue property={property} isPdf={isPdf} />
          <EstMortgageBalance property={property} isPdf={isPdf} />
          <AssessedValue property={property} isPdf={isPdf} />
          {showFincenInOI?.value && <FinCen property={property} isPdf={isPdf} />}
          {index === 0 && policyLiabilityJacket && (
            <PolicyLiability property={property} policyLiabilityJacket={policyLiabilityJacket} isPdf={isPdf} />
          )}
        </>
      )}
    </div>
  );
};

export default PropertyOrderInsights;
